import React from 'react';
import { translate } from '../Services/translation';

const Wishlist = ({ list, onRemoveItem, onAddToCart }) => {
    return (
        <div className="wishlist-item__container">
            {!list ? (
                <div className="wishlist-item__no-results">
                    <p>{translate('wishlist.empty')}</p>
                </div>
            ) : (
                list.map((item, index) => (
                    <div
                        className="wishlist-item__wrapper"
                        key={`wishlist-item-${index}`}
                    >
                        <img
                            className="wishlist-item__product-image"
                            src={item.image}
                            alt={item.name}
                        />

                        <div className="wishlist-item__product-info-container">
                            <div className="wishlist-item__product-info">
                                <div className="wishlist-item__info">
                                    <a href={item.url}>
                                        <p className="wishlist-item__title">
                                            {item.name}
                                        </p>
                                    </a>
                                </div>
                                {item.reducedPrice ? (
                                    <p className="wishlist-item__price--discount">
                                        {item.reducedPrice}
                                    </p>
                                ) : (
                                    <p className="wishlist-item__price">
                                        {item.price}
                                    </p>
                                )}
                            </div>
                            <div className="wishlist-item__button-wrapper">
                                <a
                                    className="wishlist-item__delete"
                                    onClick={() =>
                                        onRemoveItem(
                                            item.sortIndex,
                                            item.articleNumber
                                        )
                                    }
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    {translate('wishlist.delete')}
                                </a>
                                <button
                                    className="button wishlist-item__cart-button"
                                    onClick={() =>
                                        onAddToCart(item.articleNumber, 1)
                                    }
                                >
                                    {translate('wishlist.addtocart')}
                                </button>
                            </div>
                        </div>
                    </div>
                ))
            )}
        </div>
    );
};

export default Wishlist;
